// Copyright ©️ 2026 eVolve MEP, LLC

import { Switch, type SwitchProps, Loader, getSize } from '@mantine/core';

type Props = SwitchProps & { loading?: boolean };

export const WrappedSwitch = ({ disabled, thumbIcon, loading, size, ...rest }: Props) => (
  <Switch
    {...rest}
    disabled={disabled || loading}
    thumbIcon={loading ? <Loader size={getSize(size ?? 'sm', 'switch-thumb-icon')} /> : thumbIcon}
  />
);
